export default __webpack_public_path__ + "d5e3e8853d0f5eb1724f6ce2d66c5327.png";